import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "Propertystyles__Container",
  componentId: "keen-query-creator__sc-1c3q9pm-0"
})(["&&&{padding:10px 14px;height:37px;box-sizing:border-box;}&&&:focus-visible{outline:1px solid ", ";}"], colors.lightBlue[500]);

var placeholderMixin = function placeholderMixin() {
  return css(["font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;color:", ";"], transparentize(0.5, colors.black[300]));
};

export var Content = styled.div.withConfig({
  displayName: "Propertystyles__Content",
  componentId: "keen-query-creator__sc-1c3q9pm-1"
})(["&&&{display:flex;cursor:default;}"]);
export var Placeholder = styled.span.withConfig({
  displayName: "Propertystyles__Placeholder",
  componentId: "keen-query-creator__sc-1c3q9pm-2"
})(["&&&{", ";}"], placeholderMixin());
export var SearchIcon = styled.div.withConfig({
  displayName: "Propertystyles__SearchIcon",
  componentId: "keen-query-creator__sc-1c3q9pm-3"
})(["&&&{display:flex;align-items:center;margin-right:5px;}"]);
export var Input = styled.input.withConfig({
  displayName: "Propertystyles__Input",
  componentId: "keen-query-creator__sc-1c3q9pm-4"
})(["&&&{outline:none;padding:0;border:none;background:transparent;color:", ";font-size:14px;line-height:17px;font-family:'Lato Regular',sans-serif;width:100%;}&&&::placeholder,&&&::-webkit-input-placeholder{", ";}&&&:-ms-input-placeholder{", ";}"], colors.blue[500], placeholderMixin(), placeholderMixin());